import { render, staticRenderFns } from "./gains_parrains.vue?vue&type=template&id=37bf13b8"
import script from "./gains_parrains.vue?vue&type=script&lang=js"
export * from "./gains_parrains.vue?vue&type=script&lang=js"
import style0 from "./gains_parrains.vue?vue&type=style&index=0&id=37bf13b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports